const Rules = {
    getRulesStringEngNum: function(maxLength :number){
        return {
            required: '入力してください。',
                maxLength: {
                value: maxLength,
                    message: "100文字以内で入力してください"
            },
            pattern: {
                value: /^[a-zA-Z0-9\-]+$/,
                    message: "英数字のみ入力可能です"
            }
        };
    },
    getRulesStringJp: function(maxLength :number){
        return {
            required: '入力してください。',
            maxLength: {
                value: maxLength,
                message: "100文字以内で入力してください"
            },
        };
    },

    "rules_string_100": {
        required: '入力してください。',
        maxLength: {
            value: 100,
            message: "100文字以内で入力してください"
        },
        pattern: {
            value: /^[a-zA-Z0-9\-]+$/,
            message: "英数字のみ入力可能です"
        }
    },
    "rules_string_30": {
        required: '入力してください。',
        maxLength: {
            value: 30,
            message: "30文字以内で入力してください"
        },
        pattern: {
            value: /^[a-zA-Z0-9!@#$%^&*()_+,\.\-';:"<>?/\[\]{}|`~]+$/,
            message: "英数字のみ入力可能です"
        }
    },
    "rules_string_255": {
        required: '入力してください。',
        maxLength: {
            value: 255,
            message: "255文字以内で入力してください"
        },
        pattern: {
            value: /^[a-zA-Z0-9!@#$%^&*()_+,\.\-';:"<>?/\[\]{}|`~]+$/,
            message: "英数字のみ入力可能です"
        }
    },
    "login_required": {
        required: 'ログインできません。ログインIDとパスワードをお確かめください。',
    },
    "password_required": {
        required: 'パスワードを入力してください。',
        maxLength: {
        value: 255,
        message: "ログインできません。ログインIDとパスワードをお確かめください。"
        },
        pattern: {
            value: /^[a-zA-Z0-9!@#$%^&*()_+,\.\-';:"<>?/\[\]{}|`~]+$/,
            message: "ログインできません。ログインIDとパスワードをお確かめください。"
        }
    },
    "just_required": {
        required: '入力してください。',
    }

};
export default Rules;
